import { Build, Step, StepDependencyContext } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";
import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import { useStepDependenciesStore } from "~/components/build/Show/lib/useStepDependenciesStore";

type StepDependenciesResponse = Record<Step["uuid"], StepDependencyContext>;

export function stepDependenciesQueryKey(buildId: Build["id"]) {
  return ["build", buildId, "step-dependencies"];
}

export function stepDependenciesQueryOptions(
  build: Build,
  stepUploadsCount: number,
  queryOptionsArgs: Omit<UseQueryOptions<StepDependenciesResponse>, "queryKey" | "queryFn"> = {},
) {
  if (!build) {
    throw new Error("build is required");
  }

  const options: UseQueryOptions<StepDependenciesResponse> = {
    queryKey: stepDependenciesQueryKey(build.id),
    queryFn: ({ signal }) =>
      fetchStepDependencies(build, signal).then((data) => {
        if (Object.keys(data).length > 0) {
          useStepDependenciesStore.getState().setDependenciesByStep(data);
        }
        return data;
      }),
    ...queryOptionsArgs,
  };

  return queryOptions(options);
}

function fetchStepDependencies(
  build: Build,
  signal: AbortSignal,
): Promise<StepDependenciesResponse> {
  const url = new URL(`${build.buildDataBasePath}/step-dependencies`, window.location.origin);

  // We don't want to use the Database.parser method here as it will camelize stepUUID keys.
  return fetcher<StepDependenciesResponse>(url, false, { signal });
}
